import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import { FacilityListPropertyContainer } from '../../FacilityStyles';
import { ListEditIcon, ListEditLink } from 'components/common/CommonStyles';

const FacilityListItem = ({ facility }) => {
  const { t } = useTranslation();

  return (
    <Card disablePadding>
      <Grid container p={1}>
        <Grid item container xs={11} p={1}>
          <FacilityListPropertyContainer item xs={12} md={6} lg={4}>
            <span>
              <strong>{t('Facility.FacilityNumber')}:</strong>
            </span>
            <span>{facility.facilityNumber}</span>
          </FacilityListPropertyContainer>
          <FacilityListPropertyContainer item xs={12} md={6} lg={4}>
            <span>
              <strong>{t('Facility.Partner')}:</strong>
            </span>
            <span>{facility.partnerName}</span>
          </FacilityListPropertyContainer>
          <FacilityListPropertyContainer item xs={12} md={6} lg={4}>
            <span>
              <strong>{t('Facility.FacilityAmount')}:</strong>
            </span>
            <span>
              {facility.facilityAmount ? t('NUMBER', { number: facility.facilityAmount }) : ''} {facility.currencyCode}
            </span>
          </FacilityListPropertyContainer>
          <FacilityListPropertyContainer item xs={12} md={6} lg={4}>
            <span>
              <strong>{t('Facility.ValidFrom')}:</strong>
            </span>
            <span>{t('DATE', { date: facility.validFrom })}</span>
          </FacilityListPropertyContainer>
          <FacilityListPropertyContainer item xs={12} md={6} lg={4}>
            <span>
              <strong>{t('Facility.ValidUntil')}:</strong>
            </span>
            <span>{t('DATE', { date: facility.validUntil })}</span>
          </FacilityListPropertyContainer>
          <FacilityListPropertyContainer item xs={12} sm={6} lg={4}>
            <span>
              <strong>{t('Facility.State')}:</strong>
            </span>
            <span>{facility.documentStateName}</span>
          </FacilityListPropertyContainer>
        </Grid>
        <ListEditLink to={`/facilities/${facility.documentId}/${facility.siteId}`}>
          <IconButton id='offerList_editBtn' size='small' color='primary' tooltip={t('Edit')}>
            <ListEditIcon />
          </IconButton>
        </ListEditLink>
      </Grid>
    </Card>
  );
};

FacilityListItem.propTypes = {
  facility: PropTypes.object.isRequired
};

export default FacilityListItem;
